import bootbox from 'bootbox';
import Cron from 'cron-converter';
import $ from 'jquery';
import moment from 'moment';
import React, { useState, useEffect, useContext } from 'react';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Toastr from 'toastr';
import DropdownButton from '../components/bootstrap4/DropdownButton';
import Loading from '../components/Loading';
import Input from '../components/bootstrap4/Input';
import FavoriteZones from '../components/modals/FavoriteZones';
import CommonUtils from '../util/CommonUtils';
import { Table } from "antd";
import { Context } from '../../src/views/app';
import API from '../service/SiteKickAPIService';

function ZoneTimelaps(props) {
    let appContex = useContext(Context);
    let user = appContex.user;

    var timezone = user.site_selected.site_iana_timezone;
    let timelapse_schedule_columns = [];
    let attempts = 0;
    const default_scheduler = {
        start_date: new Date(moment().add(1, 'days').format('YYYY-MM-DD')),
        end_date: new Date(moment().add(1, 'days').format('YYYY-MM-DD')),
        sched_recurrence: 'N',
        sched_dperiod: 1,
        recurr_type: 'daily',
        daily: 'recurr_every_d',
        weekly: 'weekdays',
        monthly: 'nth_day',
        recurr_every_d: 1,
        recurr_every_w: 1,
        sched_recurr_count: 1,
        recurr_end_type: 'end_date',
        nth_weekday: 'fri',
        recurr_every_nth_w: 1,
        recurr_every_nth_d: 1,
        timelapse_duration_type: 'last_video_schedule'
    };

    const [schedules, setSchedules] = useState([]);
    const [schedulers, setSchedulers] = useState(default_scheduler);
    const [location_id, setLocationId] = useState(user.zone_selected ? user.zone_selected.location_id : null);
    const [selectedZone, setSelectedZone] = useState(user.zone_selected ? user.zone_selected : null);
    const [loading, setLoading] = useState(false);
    const [start_Date, setStartDate] = useState(new Date());
    const [end_Date, setEndDate] = useState(new Date());
    const [timelapse_videos, setTimelapseVideos] = useState([]);
    const [duration, setDuration] = useState(30);
    const [optoutUserId, setOptoutUserId] = useState(false);

    if (!timezone)
        timezone = moment.tz.guess();

    var days = [];
    for (let i = 1; i <= 31; i++) {
        days.push({ recurr_date: i, label: i });
    }

    const weekmap = { sun: 'Sunday', mon: 'Monday', tue: 'Tuesday', wed: 'Wednesday', thu: 'Thursday', fri: 'Friday', sat: 'Saturday' };
    const weekdays = [
        { week: 'sun', nth_weekday: 'sun', label: 'Sunday' },
        { week: 'mon', nth_weekday: 'mon', label: 'Monday' },
        { week: 'tue', nth_weekday: 'tue', label: 'Tuesday' },
        { week: 'wed', nth_weekday: 'wed', label: 'Wednesday' },
        { week: 'thu', nth_weekday: 'thu', label: 'Thursday' },
        { week: 'fri', nth_weekday: 'fri', label: 'Friday' },
        { week: 'sat', nth_weekday: 'sat', label: 'Saturday' }
    ];
    const week_idx = { sun: 0, mon: 1, tue: 2, wed: 3, thu: 4, fri: 5, sat: 6 };

    if (!user.zones) {
        Toastr.success('Accessible sites info missing ...<br>Redirecting to home ...')
        setTimeout(() => {
            window.location = user.user_role === 4 ? './owners-portal' : './dashboard';
        }, 1000);
    } else {
        var zonesMap = {};
        for (var z of user.zones) {
            zonesMap[z.location_id] = z.location_name;
        }

        if (!timezone)
            timezone = moment.tz.guess();

        let allowedDates = [];
        for (var i = 0; i < 7; i++) {
            allowedDates.push({ date: moment().add(-i, 'days').format('YYYY-MM-DD') });
        }
    }

    useEffect(() => {
        if (user.zones) {
            getMyTimelapseVideos();
            getTimeLapseSchedules();
        }
        $('.datepicker').attr('readonly', 'true');
        $('[data-toggle="tooltip"]').tooltip();
        if (props.match && props.match.params.id) {
            setLocationId(props.match.params.id);
            getMyTimelapseVideos();
        }
    }, [])

    useEffect(() => {
        getMyTimelapseVideos();
    }, [selectedZone]);

    useEffect(() => {
        getMyTimelapseVideos();
    }, [selectedZone]);

    const timelapse_table_cols = [
        {
            title: <div className='text-center'><i className="far fa-star"></i></div>,
            dataIndex: 'keep_it',
            key: 'keep_it',
            render: (keep_it, record) => <div className='text-center'><i className={keep_it ? 'text-primary fa fa-star' : 'text-primary far fa-star'}></i></div>,
            sorter: (a, b) => {
                var x = a['keep_it'];
                var y = b['keep_it'];
                return ((x < y) ? -1 : ((x > y) ? 1 : 0));
            },
            sortDirections: ["ascend", "descend", "ascend"]
        },
        {
            title: 'Start Date',
            dataIndex: 'start_time',
            key: 'start_time',
            render: (start_time, record) => moment.tz(start_time * 1000, timezone).format('YYYY-MM-DD'),
            sorter: (a, b) => {
                var x = a['start_time'];
                var y = b['start_time'];
                return ((x < y) ? -1 : ((x > y) ? 1 : 0));
            },
            sortDirections: ["ascend", "descend", "ascend"]
        },
        {
            title: 'End Date',
            dataIndex: 'end_time',
            key: 'end_time',
            render: (end_time, record) => moment.tz(end_time * 1000, timezone).format('YYYY-MM-DD'),
            sorter: (a, b) => {
                var x = a['end_time'];
                var y = b['end_time'];
                return ((x < y) ? -1 : ((x > y) ? 1 : 0));
            },
            sortDirections: ["ascend", "descend", "ascend"]
        },
        {
            title: 'Duration',
            dataIndex: 'duration',
            key: 'duration',
            render: (duration, record) => duration + "s"
        },
        {
            title: <div className='text-center'><i className="fa fa-cog"></i></div>,
            dataIndex: 'keep_it',
            key: 'keep_it',
            render: (text, record) => <div>
                <span data-toggle="tooltip" title="Play" onClick={() => playVideo(record)} className="btn btn-sm btn-primary p-1 mr-2"><i className="fa fa-play-circle"></i></span>
                <span data-toggle="tooltip" title="Share" onClick={() => shareVideo(record)} className="btn btn-sm btn-primary p-1"><i className="fa fa-share"></i></span>
            </div>
        }
    ]

    const favouriteHandler = (videoObj, event) => {
        var data = {
            user_login: user.user_login,
            user_token: user.user_token,
            site_id: videoObj.site_id,
            location_id: videoObj.location_id,
            history_id: videoObj.history_id,
            keep_it: videoObj.keep_it === 1 ? 0 : 1
        };

        if ($(event.target).hasClass("fa-spinner fa-spin")) {
            return;
        }
        $(event.target).addClass("fa-spinner fa-spin")

        CommonUtils.ajax(
            {
                url: API.TIMELAPSE.VIDEOS.UPDATE,
                type: 'POST',
                contentType: 'application/json; charset=utf-8',
                dataType: 'json',
                data: JSON.stringify(data)
            }
        ).then(
            (res) => {
                if (res && res.data) {
                    videoObj.keep_it = data.keep_it;
                    $(event.target).toggleClass("fa fa-star far fa-star")
                    $(event.target).removeClass("fa-spinner fa-spin")
                }
            },
            (res) => {
                $(event.target).toggleClass("fa fa-star far fa-star")
                $(event.target).removeClass("fa-spinner fa-spin")
                Toastr.error('Unable to update the favourite icon.');
            }
        );
    }

    const endDateOnChange = (date) => {
        setEndDate(date);
    }

    //MIN HOUR DOM MON DOW
    const onSchedulerInputChange = (key) => {
        return event => {
            let scheduler = schedulers ? { ...schedulers } : {};
            let val = null;
            if (event && event.target) {
                val = event.target.value;
                if (event.target.type === 'checkbox' || event.target.type === 'radio') {
                    val = [];
                    for (var x of $('[name="' + event.target.name + '"]')) {
                        if ($(x).prop('checked'))
                            val.push($(x).val());
                    }
                    val = val.join(',');
                }
            } else {
                val = event;
                if (key === 'location_id') {
                    scheduler['location_name'] = val['location_name'];
                }
            }

            if (key === 'recurr_every_nth_d') {
                var regPattern = /^\d+[,\d+]*$/
                if (val !== '') {
                    if (!regPattern.test(val) || val.includes(',,'))
                        return
                }
            }
            var sched_val = (typeof val === 'object' ? val[key] ? val[key] : val : val);
            scheduler[key] = sched_val;

            switch (key) {
                case 'recurr_type':
                    scheduler['sched_recurrence'] = scheduler[key] === 'one_time' ? 'N' : 'Y';
                    if (scheduler[key] === 'one_time') {
                        scheduler['start_date'] = new Date(moment().add(1, 'D').format('YYYY-MM-DD'));
                        scheduler['end_date'] = new Date(moment().add(1, 'D').format('YYYY-MM-DD'));
                        scheduler['recurr_end_type'] = 'end_date';
                    }
                    break;

                case 'recurr_every_nth_d':
                    scheduler['monthly'] = 'nth_day';
                    if (event.type === 'blur') {
                        var days = scheduler['recurr_every_nth_d'].split(',')
                        days.forEach(day => {
                            if (day > 31 || day === 0) {
                                var index = days.indexOf(day)
                                delete days[index]
                            }
                        })
                        scheduler['recurr_every_nth_d'] = days.filter(day => day !== null).join(',')
                        if (scheduler['recurr_every_nth_d'].trim().endsWith(",")) {
                            var nthDay = scheduler['recurr_every_nth_d']
                            scheduler['recurr_every_nth_d'] = nthDay.slice(0, -1)
                        }
                        if (scheduler['recurr_every_nth_d'].trim() === '')
                            scheduler['recurr_every_nth_d'] = '1'
                    }
                    break;

                case 'end_date':
                    break;

                case 'recurr_end_type':
                    let nextN = getNextNOccurences(scheduler['sched_recurr_count']);
                    if (scheduler.recurr_end_type === 'no_end_date') {
                        scheduler['end_date'] = new Date(moment(scheduler['start_date'], 'YYYY-MM-DD').add(100, 'Y').format('YYYY-MM-DD'));
                    }
                    break;

                case 'sched_recurr_count':
                    nextN = getNextNOccurences(scheduler['sched_recurr_count']);
                    scheduler['end_date'] = new Date(nextN.lastOccurence);
                    break;

                default:
                    break;
            }

            if ((key === 'start_date' || key === 'end_date')) {
                let startDate = moment(new Date(scheduler.start_date));
                let endDate = moment(new Date(scheduler.end_date));

                let diff = endDate.diff(startDate, 'days');
                if (diff < 0) {
                    Toastr.error('Start Date should be smaller than End Date');
                    if (key === 'start_date') {
                        scheduler.end_date = scheduler.start_date;
                    } else {
                        scheduler.start_date = scheduler.end_date;
                    }
                }

                if (scheduler.recurr_type === 'one_time') {
                    if (key === 'start_date')
                        scheduler.end_date = scheduler.start_date;
                    if (key === 'end_date')
                        scheduler.start_date = scheduler.end_date;
                }
            }

            if ((key === 'recurr_every_d' || key === 'sched_dperiod')) {
                if (parseInt(scheduler[key]) < 1) {
                    scheduler[key] = 1;
                }

                if (scheduler.sched_recurrence === 'N' && key === 'sched_dperiod') {
                    var startDate = moment(new Date(scheduler.start_date));
                    var endDate = moment(new Date(scheduler.end_date));
                    var diff = endDate.diff(startDate, 'days');
                    diff = diff < 0 ? 1 : (diff + 1);
                    if ((diff + "") !== event.target.value) {
                        scheduler[key] = diff;
                    }
                }
            }

            var schedule = parseSchedule(scheduler);
            for (var s in schedule) {
                scheduler[s] = schedule[s];
            }
            setSchedulers(scheduler);
        };
    }

    const getNextNOccurences = (N = 5) => {
        var scheduler = { ...schedulers };
        var schedule = parseSchedule(scheduler);

        var nextN = [];
        let cronInstance = new Cron({ outputWeekdayNames: false });
        console.clear();

        let today = moment().add(1, 'D').startOf('D');
        let startDateMoment = moment(new Date(scheduler.start_date)).startOf('D');
        if (startDateMoment.diff(today, 'days') < 0)
            startDateMoment = today;

        let endDateMoment = null;
        if (scheduler.recurr_end_type === 'end_date') {
            endDateMoment = moment(new Date(scheduler.end_date)).startOf('D');
        } else {
            //100 years is too long period for a site to finish its work :)
            endDateMoment = moment(new Date(scheduler.start_date)).add(100, 'Y').startOf('D');
        }

        let description = '';
        let cronSchedule = schedule.sched_schedule;
        let nextOccurIter = null;

        switch (scheduler.recurr_type) {
            case 'one_time':
                nextN.push(endDateMoment.clone());
                description = 'on ' + startDateMoment.format('MMM DD, YYYY - dddd');
                break;

            case 'daily':
                console.log('Daily : ', scheduler.daily);

                switch (scheduler.daily) {
                    case 'recurr_every_d':
                        cronInstance.fromString(cronSchedule);
                        nextOccurIter = cronInstance.schedule(startDateMoment.clone());
                        while (nextN.length < N) {
                            nextN.push(nextOccurIter.next());
                        }
                        nextOccurIter.reset();
                        break;

                    case 'recurr_every_wd':
                        cronInstance.fromString(cronSchedule);
                        nextOccurIter = cronInstance.schedule(startDateMoment.clone());
                        while (nextN.length < N) {
                            nextN.push(nextOccurIter.next());
                        }
                        nextOccurIter.reset();
                        break;

                    default:
                        break;
                }
                break;

            case 'weekly':
                console.log('Weekly : ', scheduler.weekly);
                cronInstance.fromString(cronSchedule);
                nextOccurIter = cronInstance.schedule(startDateMoment.clone());
                let recurrW = parseInt(scheduler.recurr_every_w);
                let weeksToAllow = [];
                while (nextN.length < N) {
                    let nextOccur = nextOccurIter.next();
                    if (weeksToAllow.length === 0 || weeksToAllow.indexOf(nextOccur.week()) > -1) {
                        nextN.push(nextOccur);
                    } else {
                        continue;
                    }
                    if (weeksToAllow.length === 0) {
                        for (let i = 1; i <= 5; i++)
                            weeksToAllow.push(nextN[0].week() + (recurrW * i));
                    }
                }
                nextOccurIter.reset();
                break;

            case 'monthly':
                console.log('Monthly : ', scheduler.monthly);

                switch (scheduler.monthly) {
                    case 'nth_weekday':
                        let startMonth = startDateMoment.clone().startOf('M');
                        let nthW = scheduler.recurr_every_nth_w;

                        while (nextN.length < N) {
                            let weekRec = startMonth.clone().weekday(week_idx[scheduler.nth_weekday]);
                            if (weekRec) {
                                let weekFoundInMonth = true;
                                for (let i = 1; i < nthW; i++) {
                                    weekRec = weekRec.add(7, 'days');
                                    if (weekRec.format('MMM') !== startMonth.format('MMM')) {
                                        weekFoundInMonth = false;
                                        break;
                                    }
                                }

                                if (weekFoundInMonth)
                                    nextN.push(weekRec);
                            }
                            startMonth = startMonth.endOf('M').add(2, 'day');
                        }
                        break;

                    case 'nth_day':
                        cronInstance.fromString(cronSchedule);
                        nextOccurIter = cronInstance.schedule(startDateMoment.clone());
                        while (nextN.length < N) {
                            nextN.push(nextOccurIter.next());
                        }
                        nextOccurIter.reset();
                        break;

                    default:
                        break;
                }

                break;

            default:
                break;
        }

        let lastOccurence = endDateMoment.clone();
        if (nextN.length > 0) {
            let nextNActual = [];
            let endDate = endDateMoment.clone();
            let startDate = startDateMoment.clone();
            for (let i = 0; i < nextN.length; i++) {
                let next = nextN[i].clone().startOf('D');
                let diff1 = endDate.diff(next, 'days');
                let diff2 = startDate.diff(next, 'days');
                console.log('Start - End :: ', startDate.format('YYYY-MM-DD') + ' -- ' + endDate.format('YYYY-MM-DD'));
                console.log('Occurence :: ', next.format('MMM DD, YYYY - dddd'));
                //console.log('Days Diffs ', diff2 + ' -- ' + diff1);

                if (diff1 >= 0 && diff2 <= 0) {
                    nextNActual.push(next.format('MMM DD, YYYY - dddd'));
                    lastOccurence = next.clone();
                }
            }
            nextN = nextNActual;
        }

        return { description: description, nextN: nextN, lastOccurence: lastOccurence.format('YYYY-MM-DD') };
    }

    const describeSchedule = () => {
        var scheduler = { ...schedulers };
        var schedule = parseSchedule(scheduler);
        var locs = scheduler.location_id;
        locs = locs ? locs.split(',') : '';

        var locString = [];
        for (var l of locs)
            locString.push(zonesMap[l]);

        locString = locString.length > 0 ? locString.join(',') : '';
        var emails = scheduler.users_share;
        emails = emails ? emails : '';

        var duration = 30;
        if (scheduler.duration !== undefined) {
            duration = scheduler.duration;
        }

        var description = schedule.sched_description;
        var next5 = [];
        console.clear();
        console.log('Schedule :: ', schedule.sched_schedule);

        let N = 5;
        if (scheduler.recurr_end_type === 'end_after')
            N = scheduler.sched_recurr_count;

        let nextNOccurences = getNextNOccurences(N);
        next5 = nextNOccurences.nextN;

        if (next5.length > 5)
            next5 = next5.slice(0, 5);

        emails = emails === '' ? user.user_email1 : emails;

        if (locString !== '' && description !== '') {
            console.log('timelapse_duration_type : ', scheduler.timelapse_duration_type);
            let durationStart = scheduler.timelapse_duration_type === 'last_video_schedule' ?
                'last video schedule' : 'beginning of the project';
            var scheduleDesc =
                '<p class="font-size-13">Create a video for each zone : ' + locString + '. <br>(Will create a separate video for each zone)' +
                '<br>From ' + durationStart + ' till the day of video creation and duration no longer than ' + duration + ' sec.' +
                '<br>Generate videos ' + description + '.' +
                '<br>Upon generation, deliver video link(s) to: ' + emails +
                '<br><br><b>Next 5 occurences will be on </b><br>' +
                (
                    (next5 && next5.length > 0) ? next5.join('<br>') :
                        '<span class="text-danger">Schedule resulted in 0 occurences. Please modify the criteria and try again.</span>'
                )
                + '<br><span class="text-white">Cron Expression: ' + schedulers.sched_schedule + '</span'
                + '</p>';
            bootbox.alert({ title: 'Schedule', okButton: false, message: scheduleDesc });
        } else {
            Toastr.error('Please select the zones for schedule. ');
        }

    }

    const parseSchedule = (scheduleObj) => {

        let recurr_type = scheduleObj.recurr_type;
        let schedule = ['0', '1'];
        let sched_description = '';

        //console.log('scheduleObj ' + JSON.stringify(scheduleObj, null, 2));

        switch (recurr_type) {
            case 'one_time':
                schedule.push(moment(new Date(scheduleObj.start_date)).format('D'));
                schedule.push(moment(new Date(scheduleObj.start_date)).format('M'));
                schedule.push('*');
                sched_description = 'On date ' + moment(new Date(scheduleObj.start_date)).format('YYYY-MM-DD');
                break;

            case 'daily':
                if (scheduleObj.daily === 'recurr_every_d') {
                    let dt = scheduleObj.recurr_every_d;
                    dt = (dt === '' || !dt) ? 1 : dt;
                    schedule.push(dt > 1 ? '*/' + dt : '*');
                    schedule.push('*');
                    schedule.push('*');
                    scheduleObj.sched_dperiod = parseInt(dt);

                    sched_description = 'every ' + (dt > 1 ? dt + ' ' : '') + 'day' + (dt > 1 ? 's' : '');
                } else {
                    schedule.push('*');
                    schedule.push('*');
                    schedule.push('mon,tue,wed,thu,fri');
                    sched_description = 'every weekday (Mon, Tue, Wed, Thu, Fri)';
                    scheduleObj.sched_dperiod = 1;
                }
                break;

            case 'weekly':
                let weekdays = !scheduleObj.weekdays || scheduleObj.weekdays === '' ? 'fri' : scheduleObj.weekdays;
                let weekdaysStr = [];
                for (let w of weekdays.split(',')) {
                    weekdaysStr.push(weekmap[w]);
                }

                schedule.push('*');
                schedule.push('*');
                schedule.push(weekdays);
                scheduleObj.sched_dperiod = parseInt(scheduleObj.recurr_every_w) * 7;
                //schedule.push("expr ( `date +%s` / 86400 - `date --date='2018-03-19' +%s` / 86400 ) % 14 == weekdays")

                sched_description = 'on ' + weekdaysStr.join(',') + ' recurring every ' + (scheduleObj.recurr_every_w) + ' week(s)';

                break;

            case 'monthly':
                let recurr_monthly_type = scheduleObj.monthly;
                scheduleObj.sched_dperiod = 31;
                if (recurr_monthly_type === 'nth_day') {
                    let days = scheduleObj.recurr_every_nth_d + '';
                    schedule.push(days);
                    schedule.push('*');
                    schedule.push('*');
                    sched_description = 'on day' + (days.indexOf(',') === -1 ? '' : 's') + ' - ' + days + ' of every month';
                } else {
                    let lastchar = parseInt(scheduleObj.recurr_every_nth_w);
                    lastchar = (lastchar === 1 ? 'st' :
                        lastchar === 2 ? 'nd' :
                            lastchar === 3 ? 'rd' : 'th');

                    schedule.push('*');
                    schedule.push('*');
                    schedule.push(scheduleObj.nth_weekday + '#' + scheduleObj.recurr_every_nth_w);
                    sched_description = ['on', scheduleObj.recurr_every_nth_w + lastchar, weekmap[scheduleObj.nth_weekday], 'of every month'].join(' ');
                }
                break;

            default:
                break;
        }

        if (scheduleObj.timelapse_duration_type === 'project_begin_date')
            scheduleObj.sched_dperiod = 365 * 100;

        return { sched_schedule: schedule.join(' '), sched_description: sched_description, sched_dperiod: scheduleObj.sched_dperiod }
    }

    const startDateOnChange = (date) => {
        setStartDate(date);
    }

    const onDurationChange = (duration) => {
        setDuration(duration.value);
    }

    const onZoneSelected = (zone) => {
        console.log(zone);
        $('video').attr('src', '');
        $('source').remove();
        $('.video_favourite').remove();
        setLocationId(zone.location_id);
        setSelectedZone(zone);
    }

    const getTimeLapseVideo = () => {

        if (!start_Date) {
            Toastr.error('Please select a start date ...');
            return;
        }
        if (!end_Date) {
            Toastr.error('Please select a end date ...');
            return;
        }

        var startDate = moment(new Date(start_Date));
        var endDate = moment(new Date(end_Date));

        if (startDate.diff(endDate, 'days') > 0) {
            Toastr.error('Start Date should be less than or equal to End Date');
            return;
        }

        if (!location_id || location_id.length === 0) {
            Toastr.error('Please select a zone ...');
            return;
        }

        var data = {
            user_login: user.user_login,
            user_token: user.user_token,
            "duration": duration,
            "start_time": "1540843200",
            "end_time": "1540893200",  //1549336200
            "fps_value": "0",
            "location_id": "5448492426492",
            "site_id": "7866638042485",
            "logo_s3": "sitesupt-location-data/cusr_" + user.customer_id + "/logo_" + user.customer_id + ".jpg",
            "site_details": "Sons of Norway Zone 7 demo"
        };

        if (!data.logo_s3)
            data.logo_s3 = 'NO LOGO';

        var currentSite = user.site_selected;
        data.site_id = currentSite.site_id;
        data.location_id = location_id;
        data.start_time = getDBTimeStamp(startDate.format('YYYY-MM-DD') + ' 05:00', currentSite.site_iana_timezone);
        data.end_time = getDBTimeStamp(endDate.format('YYYY-MM-DD') + ' 20:59', currentSite.site_iana_timezone);
        data.site_details = currentSite.site_name + ' - ' + selectedZone.location_name;

        var timelapse_video = timelapse_videos && timelapse_videos[data.site_id + '_' + data.location_id + '_' + data.start_time + '_' + data.end_time + '_' + data.duration];
        if (timelapse_video) {
            playVideo(timelapse_video);
        } else {
            submitTimelapseJob(data);
        }
    }

    const getTimeLapseSchedules = () => {
        var data = {
            user_login: user.user_login,
            user_token: user.user_token
        };

        CommonUtils.ajax(
            {
                url: API.TIMELAPSE.SCHEDULER.FETCH,
                type: 'POST',
                contentType: 'application/json; charset=utf-8',
                dataType: 'json',
                data: JSON.stringify(data)
            }
        ).then(
            (res) => {
                setSchedules(res.data);
            },
            (res) => {

            }
        );
    }

    const validateStartAndEndDates = (schedulerCopy) => {
        var startDate = moment(new Date(schedulerCopy.start_date));
        var endDate = moment(new Date(schedulerCopy.end_date));

        var diff = endDate.diff(startDate, 'days');
        diff = (diff < 0 ? 0 : (diff + 1));
        if (diff < 0) {
            Toastr.error('Start Date should be less than or equal to End Date');
            return false;
        }
        return { start_date: startDate, end_date: endDate, diff: diff };
    }

    const addTimeLapseSchedule = () => {

        const element = document.getElementsByName("users_share")[0]
        const lIsValidText = $(element).attr("isvalidtext")
        if (!(lIsValidText === "true" || lIsValidText === true)) {
            const lErrorText = $(element).attr("invaliderrormsg")

            const position = Toastr.options.positionClass
            Toastr.options.positionClass = 'toast-top-center';
            Toastr.error(lErrorText);
            Toastr.options.positionClass = position;

            return;
        }
        var currentSite = user.site_selected;
        var schedulerCopy = { ...schedulers };
        var sample_schedule = {
            "duration": "30",
            "location_id": schedulerCopy.location_id,
            "logo_s3": "sitesupt-location-data/cusr_" + user.customer_id + "/logo_" + user.customer_id + ".jpg",
            "sched_active": "1",

            "sched_dperiod": "",
            "sched_recurrence": schedulerCopy.sched_recurrence,
            "sched_schedule": "0 1 * * *",

            "site_details": currentSite.site_name + ' - ',
            "site_id": currentSite.site_id,
            "user_id": user.user_login,
            "users_share": "",
            "sched_description": schedulerCopy.sched_description,
            "optout_user_id": optoutUserId,
        }

        schedulerCopy.users_share = (!schedulerCopy.users_share || schedulerCopy.users_share === '' ? user.user_email1 : schedulerCopy.users_share);

        let dateRange = validateStartAndEndDates(schedulerCopy);
        if (!validateStartAndEndDates(schedulerCopy))
            return;

        sample_schedule.sched_start = dateRange.start_date.format('YYYY-MM-DD');
        sample_schedule.sched_end = dateRange.end_date.format('YYYY-MM-DD');

        let nextNOccurences = getNextNOccurences(5);
        if (nextNOccurences.nextN.length === 0) {
            Toastr.error('This schedule never triggers. Please revisit the schedule.');
            return;
        }

        if (schedulerCopy.recurr_type === 'weekly' && schedulerCopy.recurr_every_w !== '1') {
            schedulerCopy.sched_schedule = schedulerCopy.sched_schedule + ' ' + moment(nextNOccurences.nextN[0], 'MMM DD, YYYY - dddd').format('YYYY-MM-DD') + '@' + schedulerCopy.recurr_every_w;
        }

        if (schedulerCopy.recurr_end_type !== 'end_date')
            if (schedulerCopy.recurr_end_type === 'end_after')
                sample_schedule.sched_end = nextNOccurences.lastOccurence;

        if (!sample_schedule.logo_s3)
            sample_schedule.logo_s3 = 'NO LOGO';

        var data = {
            user_login: user.user_login,
            user_token: user.user_token,
            form_input: sample_schedule
        };

        schedulerCopy.sched_description = sample_schedule.sched_description;
        schedulerCopy.sched_dperiod = schedulerCopy.sched_dperiod && schedulerCopy.sched_dperiod <= dateRange.diff ? schedulerCopy.sched_dperiod : dateRange.diff;

        if (!schedulerCopy.location_id) {
            Toastr.error('Please select a zone ...');
            return;
        }

        if (!schedulerCopy.users_share) {
            Toastr.error('Please provide email id(s) to deliver');
            return;
        }

        if (dateRange.diff === 1 && schedulerCopy.recurr_type === 'daily') {
            schedulerCopy.sched_recurrence = 'N';
        } else {
            schedulerCopy.sched_recurrence = 'Y';
        }

        for (var k in sample_schedule) {
            if (schedulerCopy[k]) {
                data.form_input[k] = schedulerCopy[k];
            }
        }

        let location_ids = data.form_input['location_id'].split(',');
        console.log('DATA ' + JSON.stringify(data, null, 4));

        let schedulePromises = [];

        for (let l of location_ids) {
            let d = { ...data };
            d.form_input['location_id'] = l;
            d.form_input['site_details'] += zonesMap[l];
            schedulePromises.push(addTimeLapseSchedulePromise(d));
            console.log('DATA ' + JSON.stringify(d, null, 4));
        }

        Promise.all(schedulePromises).then(function (responses) {
            var successCount = 0;
            for (let response of responses) {
                if (response.status.code === 200 || response.status.code === 201)
                    successCount++;
            }
            if (successCount === location_ids.length) {
                Toastr.success('Added Schedule Successfully');
                getTimeLapseSchedules();
            }
        });
    }

    const addTimeLapseSchedulePromise = (data) => {
        return new Promise(function (resolve, reject) {
            CommonUtils.ajax(
                {
                    url: API.TIMELAPSE.SCHEDULER.ADD,
                    type: 'POST',
                    contentType: 'application/json; charset=utf-8',
                    dataType: 'json',
                    data: JSON.stringify(data)
                }
            ).then(
                (res) => {
                    resolve(res);
                },
                (res) => {
                    resolve(res);
                }
            );
        });
    }

    const toggleTimelapsSchedule = (schedule) => {
        let scheduleCopy = { ...schedule };
        scheduleCopy.sched_active = (1 - parseInt(scheduleCopy.sched_active)) + '';
        var data = {
            user_login: user.user_login,
            user_token: user.user_token,
            form_input: scheduleCopy
        };

        CommonUtils.ajax(
            {
                url: API.TIMELAPSE.SCHEDULER.ADD,
                type: 'POST',
                contentType: 'application/json; charset=utf-8',
                dataType: 'json',
                data: JSON.stringify(data)
            }
        ).then(
            (res) => {
                Toastr.success('Schedule ' + (scheduleCopy.sched_active === "1" ? "Enabled" : "Disabled") + ' Successfully');
                getTimeLapseSchedules();
            },
            (res) => {

            }
        );
    }

    const deleteTimelapsSchedule = (schedule) => {
        bootbox.confirm('Are you sure you want to remove schedule ?', function (isYes) {
            if (!isYes)
                return;

            var data = {
                user_login: user.user_login,
                user_token: user.user_token,
                form_input: schedule
            };

            CommonUtils.ajax(
                {
                    url: API.TIMELAPSE.SCHEDULER.DELETE,
                    type: 'POST',
                    contentType: 'application/json; charset=utf-8',
                    dataType: 'json',
                    data: JSON.stringify(data)
                }
            ).then(
                (res) => {
                    Toastr.success('Schedule removed successfully');
                    getTimeLapseSchedules();
                },
                (res) => {

                }
            );
        });
    }

    const submitTimelapseJob = (data) => {
        setLoading(true);

        CommonUtils.ajax(
            {
                url: API.TIMELAPSE.BASE,
                type: 'POST',
                contentType: 'application/json; charset=utf-8',
                dataType: 'json',
                data: JSON.stringify(data)
            }
        ).then(
            (res) => {
                if (res) {
                    if (res.status.code === 200) {
                        var request_id = res.data.request_id;
                        var key_id = res.data.key_id;
                        pollTimelapseJob(request_id, key_id);
                    } else if (res.status.code === 201 && res.status.message === 'Already Exists') {
                        setLoading(false);
                        getMyTimelapseVideos();
                        Toastr.error('Possible Reasons: <br>1. Time-lapse video already exists. <br>2. Similar request is already in progress.');
                    } else {
                        setLoading(false);
                    }
                }
            },
            (res) => {

            }
        );
    }

    const shareVideo = (v) => {
        v.user_login = user.user_login;
        v.user_token = user.user_token;
        bootbox.prompt({
            title: "Enter Recipient Email IDs <small> (semicolon separated)</small>",
            closeButton: false,
            callback: function (result) {
                if (!result)
                    return true;

                var regPattern = /^([a-zA-Z0-9_\-.]+)@([a-zA-Z0-9_\-.]+)\.([a-zA-Z]{2,5})$/;
                var emailArray = result.split(';');
                for (var i = 0; i < emailArray.length; i++) {
                    var email = emailArray[i].trim()
                    if (!regPattern.test(email)) {
                        Toastr.error('Invalid email address!');
                        return true
                    }
                }
                var data = { ...v };
                data.share_email = result;

                CommonUtils.ajax(
                    {
                        url: API.TIMELAPSE.SHARE_VIDEO,
                        type: 'POST',
                        contentType: 'application/json; charset=utf-8',
                        dataType: 'json',
                        data: JSON.stringify(data)
                    }
                ).then(
                    (res) => {
                        if (res.status && res.status.code === 200) {
                            Toastr.success('Video shared successfully !');
                        } else {
                            Toastr.error('Error occurred ... Please try again !');
                        }
                    },
                    (res) => {

                    }
                );
            }
        });
    }

    const pollTimelapseJob = (messageId, keyId) => {
        var data = {
            user_login: user.user_login,
            user_token: user.user_token,
            messageId: messageId,
            key_id: keyId,
            isRead: true
        };

        CommonUtils.ajax(
            {
                url: API.TIMELAPSE.BASE,
                type: 'POST',
                contentType: 'application/json; charset=utf-8',
                dataType: 'json',
                data: JSON.stringify(data)
            }
        ).then(
            (res) => {
                console.log(res)
                var done = false;
                if (res && res.data && res.data.length > 0 && res.data[0]['timelaps_video_url']) {
                    done = true;
                    playVideo({ video_url: res.data[0]['timelaps_video_url'] });
                    setLoading(false);
                    getMyTimelapseVideos();
                }
                if (!done) {
                    setTimeout(() => {
                        attempts++;
                        pollTimelapseJob(messageId, keyId);
                    }, 10000);
                }

                if (!done && attempts === 3) {
                    setLoading(false);
                    bootbox.alert({
                        closeButton: false,
                        message: 'Timelapse video generation is in progress. Check back in 10 minutes. ',
                        buttons: {
                            ok: {
                                label: 'OK',
                                className: 'btn-primary btn-sm m-0'
                            }
                        }
                    });
                }
            },
            (res) => {

            }
        );
    }

    const playVideo = (videoObj) => {
        var videoContainer = document.getElementById('timelaps_video_container');
        videoContainer.innerHTML = '';
        var video = document.createElement('video');
        video.setAttribute('width', '100%');
        video.setAttribute('controls', true);
        var source = document.createElement('source');
        source.setAttribute('src', videoObj.video_url);
        source.setAttribute('type', 'video/mp4');
        video.appendChild(source);
        videoContainer.appendChild(video);
        if (videoObj.history_id) {
            let favouriteIcon = document.createElement("i");
            favouriteIcon.setAttribute("class", `video_favourite ${videoObj.keep_it === 1 ? "fa fa-star" : "far fa-star"}`);
            favouriteIcon.addEventListener('click', (event) => favouriteHandler(videoObj, event));
            videoContainer.appendChild(favouriteIcon);
        }

        var promise = video.play();
        if (promise !== undefined) {
            promise.catch(error => {

            }).then(() => {

            })
        }
    }

    const getDBTimeStamp = (date, tz, format) => {
        var timestampFormat = format ? format : 'X';
        if (tz) {
            var currentDateAt12AM = (date.length === 10) ? date + ' 00:00' : date; //moment().format('YYYY-MM-DD') + ' 00:00';
            var userTime = moment.tz(currentDateAt12AM, 'YYYY-MM-DD HH:mm', tz);
            var DBTime = userTime.tz('UTC'); // UTC or DB time at userTime.
            return DBTime.format(timestampFormat);
        } else {
            return moment(date.length === 10 ? date + ' 00:00' : date, 'YYYY-MM-DD').format(timestampFormat);
        }
    }

    const getMyTimelapseVideos = () => {
        if (!location_id)
            return;
        var currentSite = user.site_selected;
        var data = {
            user_login: user.user_login,
            user_token: user.user_token,
            site_id: currentSite.site_id,
            location_id: location_id
        };

        setLoading(true);
        setTimelapseVideos([]);
        CommonUtils.ajax(
            {
                url: API.TIMELAPSE.VIDEOS.FETCH,
                type: 'POST',
                contentType: 'application/json; charset=utf-8',
                dataType: 'json',
                data: JSON.stringify(data)
            }
        ).then(
            (res) => {
                if (res) {
                    var timelapse_videos_map = {};
                    if (res.data) {
                        for (var tl of res.data) {
                            var slse = tl.site_id + '_' + tl.location_id + '_' + tl.start_time + '_' + tl.end_time + '_' + tl.duration;
                            timelapse_videos_map[slse] = tl;
                        }
                    }
                    setTimelapseVideos(Object.values(timelapse_videos_map));
                    setLoading(false);
                    setTimeout(function () {
                        $('[data-toggle="tooltip"]').tooltip();
                    }, 1000);
                }
            },
            (res) => {
                setLoading(false);
            }
        );

    }

    const editFavoriteZones = () => {
        $('#fav-zones-link').trigger('click');
    }

    const prepareTimelapseSchedulesTableData = () => {
        let uniqueLocations = [];
        let uniqueEmails = [];
        if (schedules) {
            uniqueLocations = schedules.map(z => {
                for (let e of z.users_share.split(','))
                    uniqueEmails.push({ text: e, value: e });
                return { text: zonesMap[z.location_id], value: z.location_id };
            });
            uniqueLocations = CommonUtils.getUnique(uniqueLocations, 'value');
            uniqueLocations = uniqueLocations.sort((a, b) => CommonUtils.sort(a, b, 'text'));
            uniqueEmails = CommonUtils.getUnique(uniqueEmails, 'value');
            uniqueEmails = uniqueEmails.sort((a, b) => CommonUtils.sort(a, b, 'text'));
        }

        timelapse_schedule_columns = [{
            title: "Location",
            dataIndex: "location_id",
            key: "location_id",
            width: 200,
            filters: uniqueLocations,
            render: (location_id) => zonesMap[location_id],
            onFilter: (value, record) => (record.location_id === value)
        },
        {
            title: "Schedule Description",
            dataIndex: "sched_description",
            key: "sched_description",
            render: (sched_description) => sched_description.length > 0 ? (sched_description.charAt(0).toUpperCase() + sched_description.substring(1)) : ''
        },
        {
            title: "Recipients",
            dataIndex: "users_share",
            key: "users_share",
            filters: uniqueEmails,
            onFilter: (value, record) => (record.users_share.indexOf(value) !== -1)
        },
        {
            title: "Recurring",
            dataIndex: "sched_recurrence",
            key: "sched_recurrence",
            width: 100,
            render: (sched_recurrence) => (sched_recurrence === 'Y' ? 'Yes' : 'No')
        },
        {
            title: "Period",
            dataIndex: "sched_dperiod",
            key: "sched_dperiod",
            width: 100,
            render: (sched_dperiod) => sched_dperiod + ' day(s)'
        }];


        if (CommonUtils.hasPermission('SITESUPT-UI-TIMELAPSE-SCHEDULES-MODIFY')) {
            timelapse_schedule_columns = timelapse_schedule_columns.concat(
                [{
                    title: "Enabled",
                    key: "users_share",
                    width: 75,
                    render: (sched_description, schedule) => <i data-toggle="tooltip" title={schedule.sched_active === '0' ? 'Enable Schedule' : 'Disable Schedule'} style={{ fontSize: '22px' }} className={schedule.sched_active === '1' ? 'fa fa-toggle-on text-success cursor-pointer' : 'fa fa-toggle-off text-gray cursor-pointer'} onClick={() => toggleTimelapsSchedule(schedule)} ></i>
                },
                {
                    title: <i className="fa fa-cog"></i>,
                    key: "sched_active",
                    width: 50,
                    className: 'text-center',
                    render: (sched_description, record) => <button className="btn btn-sm btn-danger p-0" onClick={() => deleteTimelapsSchedule(record)}><i className="fa fa-trash-alt" data-toggle="tooltip" title="Remove Schedule"></i></button>
                }]
            );
        }

    }

    const handleEmailOption = () => {
        var optout_user_id = optoutUserId;
        setOptoutUserId(!optout_user_id);
    }

    let site_id = user.site_selected ? user.site_selected.site_id : '0';
    prepareTimelapseSchedulesTableData();
    let timelapseZones = user.zones;
    // By default we show all zones, if favorites only favourites
    let fav_zones = user.fav_zones;
    fav_zones = fav_zones && fav_zones[user.site_selected.site_id];
    fav_zones = fav_zones === undefined || fav_zones.length === 0 ? [] : fav_zones;

    if (CommonUtils.hasPermission('SITESUPT-UI-OWNERS-PORTAL')) {
        let allowed_zones = (user.user_zones && user.user_zones[parseInt(site_id)]) || [];
        if (fav_zones.length > 0) {
            fav_zones = fav_zones.filter(z => allowed_zones.length > 0 ? allowed_zones.includes(z) : true);
        }
        if (!fav_zones.includes(location_id)) {
            fav_zones.push(location_id);
        }
    }

    if (fav_zones && fav_zones.length > 0) {
        timelapseZones = user.zones.filter(z => fav_zones.indexOf(z.location_id + '') !== -1);
    }

    return (
        user.zones && <React.Fragment>
            <div className="page-container btn-light-pointerless">
                <div className="row">
                    <div className="col-md-12 p-0">
                        <ul className="nav nav-tabs">
                            <li className="nav-item"><a data-toggle="tab" href="#timelapse-videos" className="nav-link p-1 px-3 active">View Time-lapse Videos</a></li>
                            {CommonUtils.hasPermission('SITESUPT-UI-TIMELAPSE-SCHEDULES-CREATE') && <li className="nav-item"><a data-toggle="tab" href="#timelapse-scheduler-create" className="nav-link p-1 px-3">Create Video Schedule</a></li>}
                            {CommonUtils.hasPermission('SITESUPT-UI-TIMELAPSE-SCHEDULES-MANAGE') && <li className="nav-item"><a data-toggle="tab" href="#timelapse-scheduler-manage" className="nav-link p-1 px-3">Manage Video Schedules</a></li>}
                            {CommonUtils.hasPermission('SITESUPT-UI-TIMELAPSE-SCHEDULES-MODIFY') && <li className="nav-item"><a id="fav-zones-link" data-toggle="tab" href="#timelapse-scheduler-fav-zones" className="nav-link p-1 px-3">Set Favorite Zones</a></li>}
                        </ul>
                    </div>
                    <div className="col-md-12 bg-white border-rounded-b">
                        <div className="tab-content">
                            <div id="timelapse-videos" className="tab-pane fade in active show">
                                <div className="row">
                                    <div className="col-md-8 pt-4">
                                        {!loading &&
                                            <React.Fragment>
                                                <div className="row">
                                                    <div className="col-md-3 mt-2 mt-md-0" style={{ lineHeight: '24px' }}>
                                                        <button className="box-shadow-none btn btn-sm btn-light d-inline btn-radius-right-0 px-2 py-custom">
                                                            Zone
                                                        </button>
                                                        <DropdownButton
                                                            className='btn btn-sm dropdown-toggle btn-radius-left-0 text-dark py-custom w-75'
                                                            onOptionClick={(z) => onZoneSelected(z)}
                                                            default={user.zones.length === 0 ? "No zones found" : 'Choose Zone'}
                                                            selected={location_id}
                                                            opts={timelapseZones}
                                                            field_attr='location_id'
                                                            value_attr='location_name'
                                                            maxChars={12}
                                                            dropdown_footer={
                                                                CommonUtils.hasPermission('SITESUPT-UI-TIMELAPSE-SCHEDULES-MODIFY') &&
                                                                <React.Fragment>
                                                                    <button className="btn btn-sm btn-primary" style={{ borderRadius: '0px', width: '100%', lineHeight: '27px' }} onClick={() => editFavoriteZones()}>Edit Favorite Zones</button>
                                                                </React.Fragment>
                                                            }
                                                        />
                                                    </div>

                                                    {CommonUtils.hasPermission('SITESUPT-UI-TIMELAPSE-SCHEDULES-CREATE') &&
                                                        <>
                                                            <div className="col-md-3 mt-2 mt-md-0" style={{ lineHeight: '24px' }}>
                                                                <button className="box-shadow-none w-50 btn btn-sm btn-light d-inline btn-radius-right-0 px-2 py-custom">
                                                                    Start
                                                                </button>
                                                                <DatePicker
                                                                    className="datepicker w-100 btn btn-sm dropdown-toggle btn-radius-left-0 text-dark py-custom readonly"
                                                                    selected={start_Date}
                                                                    onChange={startDateOnChange}
                                                                    dateFormat="yyyy-MM-dd"
                                                                    maxDate={new Date()}
                                                                />
                                                            </div>

                                                            <div className="col-md-3 mt-2 mt-md-0">
                                                                <button className="box-shadow-none w-50 btn btn-sm btn-light d-inline btn-radius-right-0 px-2 py-custom">
                                                                    End
                                                                </button>
                                                                <DatePicker
                                                                    className="datepicker w-100 btn btn-sm dropdown-toggle btn-radius-left-0 text-dark py-custom"
                                                                    selected={end_Date}
                                                                    onChange={endDateOnChange}
                                                                    dateFormat="yyyy-MM-dd"
                                                                    maxDate={new Date()}
                                                                />
                                                            </div>

                                                            <div className="col-md-3 mt-2 mt-md-0" style={{ lineHeight: '24px' }}>
                                                                <button className="box-shadow-none btn btn-sm btn-light d-inline btn-radius-right-0 px-2 py-custom">
                                                                    <small>Duration</small>
                                                                </button>
                                                                <DropdownButton
                                                                    className='btn btn-sm dropdown-toggle btn-radius-left-0 text-dark py-custom w-75'
                                                                    default={'30 Secs'}
                                                                    selected={duration}
                                                                    onOptionClick={onDurationChange}
                                                                    opts={[
                                                                        { value: 10, label: '10 Secs' },
                                                                        { value: 15, label: '15 Secs' },
                                                                        { value: 30, label: '30 Secs' },
                                                                        { value: 60, label: '60 Secs' },
                                                                        { value: 90, label: '90 Secs' }]
                                                                    }
                                                                    field_attr='value'
                                                                    value_attr='label' />
                                                            </div>
                                                        </>
                                                    }

                                                </div>

                                                {CommonUtils.hasPermission('SITESUPT-UI-TIMELAPSE-SCHEDULES-CREATE') &&
                                                    <div className="row">
                                                        <div className="col-md-12">
                                                            <button className="btn btn-sm btn-primary mt-3 p-1 pull-right" onClick={() => getTimeLapseVideo()}>Generate Time-lapse Video</button>
                                                        </div>
                                                    </div>
                                                }

                                            </React.Fragment>
                                        }
                                        {
                                            loading && <Loading className="mt-5">Preparing time-lapse video ...</Loading>
                                        }
                                        <div className={loading ? 'invisible' : 'row py-3 mt-2'}>
                                            <div className="col-md-12" id="timelaps_video_container">
                                                <video width="100%" controls id="timelaps_video_url" />
                                            </div>
                                        </div>

                                    </div>
                                    <div className="col-md-4 p-0" style={{ "borderLeft": "5px solid #e6e6e6" }}>
                                        <div className="bg-light text-primary p-2">Videos History</div>
                                        <Table
                                            loading={loading}
                                            rowKey="history_id"
                                            dataSource={timelapse_videos || []}
                                            columns={timelapse_table_cols}
                                            pagination={false}
                                        />
                                    </div>
                                </div>
                            </div>

                            <div id="timelapse-scheduler-create" className="tab-pane fade my-4 mx-2">
                                <label className="text-primary text-bold">Create Schedule for Zones:</label>
                                <div className="row mb-3">
                                    {
                                        timelapseZones.map((z, i) => (
                                            <div key={'location' + i} className="col-md-4">
                                                <input id={z.location_id} type="checkbox" value={z.location_id} name="location_id" onChange={onSchedulerInputChange('location_id')} />
                                                <label htmlFor={z.location_id}>{z.location_name}</label>
                                            </div>
                                        ))
                                    }
                                </div>
                                <label className="text-primary text-bold">Schedule Delivery</label>
                                <br></br>
                                <span className="bg-section">Recurrence Pattern</span>
                                <div className="border-section border-white">
                                    <div className="row m-0">
                                        <div className="col-3 col-md-2 pr-0">
                                            {
                                                [
                                                    { recurr_type: 'daily', label: 'Daily' },
                                                    { recurr_type: 'weekly', label: 'Weekly' },
                                                    { recurr_type: 'monthly', label: 'Monthly' }
                                                ].map((w, i) => (
                                                    <div key={'week' + i} className={schedulers.recurr_type === w.recurr_type ? "bg-light pl-2 pt-2 border-rounded-l" : "pl-2 pt-2 border-rounded-l"}>
                                                        <input defaultChecked={schedulers.recurr_type === w.recurr_type} id={w.recurr_type} type="radio" value={w.recurr_type} name="recurr_type" onChange={onSchedulerInputChange('recurr_type')} />
                                                        <label htmlFor={w.recurr_type}>{w.label}</label>
                                                    </div>
                                                ))
                                            }
                                        </div>

                                        {
                                            schedulers.recurr_type === 'daily' &&
                                            <div className="col-9 col-md-10 py-2 bg-light border-rounded-r border-rounded-bl">
                                                <div>
                                                    <input defaultChecked={schedulers.daily === 'recurr_every_d'} type="radio" id="recurr_every" name="daily" value="recurr_every_d" onChange={onSchedulerInputChange('daily')} />
                                                    <label htmlFor="recurr_every" className="d-inline">
                                                        <div className="col-md-12 d-inline p-0 m-0">
                                                            Recur every &nbsp;<Input className="btn btn-sm bg-white form-control d-inline w-50" type="number" value={schedulers.recurr_every_d} onChange={onSchedulerInputChange('recurr_every_d')} /> day(s)
                                                        </div>
                                                    </label>
                                                </div>
                                                <div className="mt-2">
                                                    <input defaultChecked={schedulers.daily === 'recurr_every_wd'} type="radio" id="recurr_every_wd" name="daily" value="recurr_every_wd" onChange={onSchedulerInputChange('daily')} />
                                                    <label htmlFor="recurr_every_wd" className="d-inline">
                                                        <div className="col-md-12 d-inline p-0 m-0">Every Weekday</div>
                                                    </label>
                                                </div>
                                            </div>
                                        }

                                        {
                                            schedulers.recurr_type === 'weekly' &&
                                            <React.Fragment>
                                                <div className="col-9 col-md-10 pt-2 mt-md-0 bg-light ml-0 border-rounded" style={{ lineHeight: '24px' }}>
                                                    <div className="row">
                                                        <div className="col-md-12 px-3">
                                                            <input id="weekdays" defaultChecked={schedulers.weekly === "weekdays"} type="radio" value="weekdays" name="weekly" onChange={onSchedulerInputChange('weekly')} />
                                                            <label htmlFor="weekdays">
                                                                <span>Recur every
                                                                    <DropdownButton
                                                                        minWidth="50px"
                                                                        className='d-inline btn-white btn btn-sm dropdown-toggle text-dark mx-1 py-custom'
                                                                        default={"1"}
                                                                        selected={schedulers.recurr_every_w}
                                                                        onOptionClick={onSchedulerInputChange('recurr_every_w')}
                                                                        opts={[
                                                                            { recurr_every_w: '1', label: '1' },
                                                                            { recurr_every_w: '2', label: '2' },
                                                                            { recurr_every_w: '3', label: '3' },
                                                                            { recurr_every_w: '4', label: '4' }
                                                                        ]}
                                                                        field_attr='recurr_every_w'
                                                                        value_attr='label' />
                                                                    week(s) on</span>
                                                                <div className="row px-4 mt-2">
                                                                    {
                                                                        weekdays.map((w, i) => (
                                                                            <div key={'week' + i} className="col-md-3">
                                                                                <input defaultChecked={schedulers.weekdays && schedulers.weekdays.indexOf(w.week) !== -1} id={w.week} type="checkbox" value={w.week} name="weekdays" onChange={onSchedulerInputChange('weekdays')} />
                                                                                <label htmlFor={w.week}>{w.label}</label>
                                                                            </div>
                                                                        ))
                                                                    }
                                                                </div>
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </React.Fragment>
                                        }
                                        {
                                            schedulers.recurr_type === 'monthly' &&
                                            <React.Fragment>
                                                <div className="col-9 col-md-10 pt-2 mt-md-0 bg-light ml-0 border-rounded" style={{ lineHeight: '24px' }}>
                                                    <div className="row">
                                                        <div className="col-md-12 px-3">
                                                            <input id="nth_day" type="radio" checked={schedulers.monthly === "nth_day"} value="nth_day" name="monthly" onChange={onSchedulerInputChange('monthly')} />
                                                            <label htmlFor="nth_day">
                                                                <span>On specific day(s) of month</span>
                                                                <br /><input className="mt-2 ml-4 form-control bg-white" onBlur={onSchedulerInputChange('recurr_every_nth_d')} type="text" value={schedulers.recurr_every_nth_d} name="recurr_every_nth_d" onChange={onSchedulerInputChange('recurr_every_nth_d')} />
                                                                <small className="mt-2 ml-4" >Comma separated dates. Ex: 1,2,3</small>
                                                            </label>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-md-12 px-3">
                                                            <input id="nth_weekday" type="radio" checked={schedulers.monthly === "nth_weekday"} value="nth_weekday" name="monthly" onChange={onSchedulerInputChange('monthly')} />
                                                            <label htmlFor="nth_weekday">
                                                                <span>On Nth weekday of month</span><br />
                                                                <span className="mt-2 pl-4 mr-1">On</span>
                                                                <DropdownButton
                                                                    minWidth="65px"
                                                                    className='d-inline btn btn-sm btn-white dropdown-toggle text-dark py-custom'
                                                                    default={"1st"}
                                                                    selected={schedulers.recurr_every_nth_w}
                                                                    onOptionClick={onSchedulerInputChange('recurr_every_nth_w')}
                                                                    opts={[
                                                                        { recurr_every_nth_w: 1, label: '1st' },
                                                                        { recurr_every_nth_w: 2, label: '2nd' },
                                                                        { recurr_every_nth_w: 3, label: '3rd' },
                                                                        { recurr_every_nth_w: 4, label: '4th' },
                                                                        { recurr_every_nth_w: 5, label: '5th' }]
                                                                    }
                                                                    field_attr='recurr_every_nth_w'
                                                                    value_attr='label' />

                                                                <DropdownButton
                                                                    className='d-inline btn-white btn btn-sm dropdown-toggle text-dark py-custom w-75'
                                                                    default={"Friday"}
                                                                    selected={schedulers.nth_weekday}
                                                                    onOptionClick={onSchedulerInputChange('nth_weekday')}
                                                                    opts={weekdays}
                                                                    field_attr='week'
                                                                    value_attr='label' />
                                                                <span className="ml-1 mt-2">of month</span>
                                                            </label>
                                                        </div>
                                                    </div>

                                                </div>
                                            </React.Fragment>
                                        }

                                    </div>
                                </div>


                                <div className="row">
                                    <div className="col-md-6">
                                        <span className="bg-section">Range of Recurrence</span>
                                        <div className="border-section">
                                            <div className="row m-0">
                                                <div className="col-md-4 mt-md-0">
                                                    Start :&nbsp;
                                                    <DatePicker
                                                        className="datepicker w-100 btn btn-sm dropdown-toggle text-dark py-custom readonly"
                                                        selected={schedulers.start_date}
                                                        onChange={onSchedulerInputChange('start_date')}
                                                        dateFormat="yyyy-MM-dd"
                                                        minDate={new Date(moment().add(1, 'D').format('YYYY-MM-DD'))}
                                                        maxDate={new Date(moment().add(3, 'Y').format('YYYY-MM-DD'))}
                                                    />
                                                </div>

                                                <div className="col-md-8 mt-md-0">
                                                    <input id="recurr_end_type_1" checked={schedulers.recurr_end_type === 'end_date'} type="radio" value="end_date" name="recurr_end_type" onChange={onSchedulerInputChange('recurr_end_type')} />
                                                    <label htmlFor="recurr_end_type_1" className="d-inline"></label>
                                                    End By :&nbsp;
                                                    <DatePicker
                                                        className="datepicker w-100 btn btn-sm dropdown-toggle text-dark py-custom"
                                                        selected={schedulers.end_date}
                                                        onChange={onSchedulerInputChange('end_date')}
                                                        dateFormat="yyyy-MM-dd"
                                                        minDate={new Date(moment().add(1, 'D').format('YYYY-MM-DD'))}
                                                        maxDate={new Date(moment().add(3, 'Y').format('YYYY-MM-DD'))}
                                                    />
                                                </div>

                                            </div>
                                            {schedulers.recurr_type !== 'one_time' &&
                                                <React.Fragment>
                                                    <div className="row m-0">
                                                        <div className="col-md-8 offset-md-4 mt-2 mt-md-1">
                                                            <input id="recurr_end_type_3" defaultChecked={schedulers.recurr_end_type === 'no_end_date'} type="radio" value="no_end_date" name="recurr_end_type" onChange={onSchedulerInputChange('recurr_end_type')} />
                                                            <label htmlFor="recurr_end_type_3" className="d-inline"></label>
                                                            No End Date &nbsp;
                                                        </div>
                                                    </div>
                                                </React.Fragment>
                                            }

                                        </div>
                                    </div>

                                    <div className="col-md-6">
                                        <span className="bg-section">Generate Time-lapse</span>
                                        <div className="border-section">
                                            <div className="row px-2">
                                                <div className="col-md-12">
                                                    <input id="timelapse_coverage1" defaultChecked={schedulers.timelapse_duration_type === 'project_begin_date'} type="radio" value="project_begin_date" name="timelapse_duration_type" onChange={onSchedulerInputChange('timelapse_duration_type')} />
                                                    <label htmlFor="timelapse_coverage1" className="d-inline"></label>
                                                    From Beginning of Project
                                                </div>
                                            </div>
                                            <div className="row px-2 py-1">
                                                <div className="col-md-12">
                                                    <input id="timelapse_coverage2" defaultChecked={schedulers.timelapse_duration_type === 'last_video_schedule'} type="radio" value="last_video_schedule" name="timelapse_duration_type" onChange={onSchedulerInputChange('timelapse_duration_type')} />
                                                    <label htmlFor="timelapse_coverage2" className="d-inline"></label>
                                                    Since Last Video Schedule
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                                <div className="pt-2 mt-3 hide">
                                    <span className="d-inline" data-toggle="tooltip" title="On the day of timelapse video generation, how many past days of video to be generated">For the period of : </span>
                                    <Input id="sched_dperiod" type="number" className="btn btn-sm form-control d-inline w-75" value={schedulers.sched_dperiod} onChange={onSchedulerInputChange('sched_dperiod')}></Input>
                                    <span className="d-inline"> day(s)</span>
                                </div>

                                <div className="pt-2">
                                    <span className="d-inline">Video Duration: </span>
                                    <DropdownButton
                                        className='d-inline btn btn-sm dropdown-toggle text-dark py-custom w-75'
                                        default={'30 Secs'}
                                        selected={schedulers.duration}
                                        onOptionClick={onSchedulerInputChange('duration')}
                                        opts={[
                                            { duration: 10, label: '10 Secs' },
                                            { duration: 15, label: '15 Secs' },
                                            { duration: 30, label: '30 Secs' },
                                            { duration: 60, label: '60 Secs' },
                                            { duration: 90, label: '90 Secs' }]
                                        }
                                        field_attr='duration'
                                        value_attr='label' />
                                </div>

                                <div className="pt-2">
                                    <span className="d-inline">Share Video Link(s) with : </span>
                                    <Input style={{ width: '250px' }} name="users_share" className="form-control text-left d-inline" type="email" onBlur={onSchedulerInputChange('users_share')} defaultValue={schedulers.users_share} placeholder="Email-1, Email-2" />
                                </div>

                                <div className="pt-2">
                                    <span className="d-inline">
                                        <i className={optoutUserId ? 'far text-primary fa-lg fa-check-square cursor-pointer' : 'far text-primary fa-lg fa-square cursor-pointer'} onClick={handleEmailOption} />
                                        <label className='ml-2'>Opt out from email notifications for current logged in user: {user.user_login}</label>
                                    </span>
                                </div>

                                <div className="row mt-3">
                                    <div className="col-md-12 text-center">
                                        <button className="btn btn-sm btn-primary mr-1" onClick={() => addTimeLapseSchedule()}>Create Video Schedule</button>
                                        <label className="btn-link bg-white" onClick={() => describeSchedule()}>Describe Schedule(s)</label>
                                    </div>
                                </div>

                            </div>

                            <div id="timelapse-scheduler-manage" className="tab-pane fade my-4 mx-2">
                                <div className="row bg-white">
                                    <div className="col-md-12">
                                        {
                                            schedules &&
                                            <Table rowKey={'schedule_id'} dataSource={schedules.filter(z => zonesMap[z.location_id])} columns={timelapse_schedule_columns} scroll={{ x: 'calc(700px + 20%)', y: 'auto' }}></Table>
                                        }
                                    </div>
                                </div>
                            </div>

                            <div id="timelapse-scheduler-fav-zones" className="tab-pane fade my-4 mx-2">
                                <FavoriteZones></FavoriteZones>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </React.Fragment >
    )
}

export default ZoneTimelaps;